import { render, staticRenderFns } from "./LprDetection.vue?vue&type=template&id=416f80bc"
import script from "./LprDetection.vue?vue&type=script&lang=js"
export * from "./LprDetection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports